'use client'

import { Typography } from '@pw-tech/omni-ui'
import React from 'react'

type TypographyWrapperProps = {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  color?: string
  decoration?: 'none' | 'underLine' | 'strikeThrough'
  weight?: 'bold' | 'semi-bold' | 'medium'
  variant:
    | 'display1'
    | 'display2'
    | 'heading1'
    | 'heading2'
    | 'heading3'
    | 'heading4'
    | 'subHeading'
    | 'regular'
    | 'small'
    | 'tiny'
    | 'label'
  component?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span' | 'label'
}

const TypographyWrapper: React.FC<TypographyWrapperProps> = ({
  children,
  color = '#1B2124',
  decoration = 'none',
  weight = 'bold',
  className = '',
  style = {},
  variant = 'subHeading',
  component = 'div',
}) => {
  return (
    <Typography
      color={color}
      decoration={decoration}
      variant={variant}
      weight={weight}
      className={className}
      style={style}
      component={component}
    >
      {children}
    </Typography>
  )
}

export default TypographyWrapper
